

const apiUrl  = process.env.VUE_APP_API;

const WPVUE = window.WPVUE;
const cacheKey = (WPVUE && WPVUE.persistor_key) ? WPVUE.persistor_key : new Date().getTime();

const api = {
    
   // eslint-disable-next-line 
    getRevision: (params) =>  axios.get(apiUrl, {
        params: {
            action : 'revision',
            cache : new Date().getTime(),
            ...params
        }
    }),
    // eslint-disable-next-line
    getTaxonomy: (params) =>  axios.get(apiUrl, {
        params: {
            action : 'term',
            cache : cacheKey,
            ...params
        }
    }),
    // eslint-disable-next-line
    getMetaRelated: (params) =>  axios.get(apiUrl, {
        params: {
            action : 'related',
            cache : cacheKey,
            ...params
        }
    }),
    // eslint-disable-next-line
    getPost: (params) =>  axios.get(apiUrl, {
        params: {
            action : 'post',
            cache : cacheKey,
            ...params
        }
    }),
    // eslint-disable-next-line
    getMenu: (location = 'primary-menu') =>  axios.get(apiUrl, {
        params: {
            action : 'menu',
            cache : cacheKey,
            'location' : location
        }
    }),
    
    // eslint-disable-next-line
    getConfig: () =>  axios.get(apiUrl, {
        params: {
            cache : cacheKey, //we always want refresh it no matter what
            action : 'config'
        }
    })
}


export default api;